<template>
  <v-card>
    <vue-card-title
      :title="'Process Task'"
      :subtitle="'Refer to the following information for process task.'"
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          v-if="fetched"
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="(showForm = true) && (selectedObj = {})"
        >
          Create Process Task
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col cols="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" cols="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" cols="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-col
          v-for="(item, itemIndex) in fetchedData"
          v-else
          :key="`item-${itemIndex}`"
          md="3"
          cols="12"
        >
          <v-card>
            <v-card-text class="text-center">
              <h4 class="mb-3">
                {{ item.name }}
              </h4>
              <small>{{ item.description }}</small>
            </v-card-text>
            <v-card-text class="text-center">
              <a
                class="font-0 grey--text cursor-pointer"
                @click="(selectedObj = item) && (showForm = true)"
                >Update</a
              >
              <span class="mx-1 font-0 grey--text">|</span>
              <a
                class="font-0 grey--text cursor-pointer link"
                @click="
                  (selectedObj = item) && (confirmServiceCategoryDelete = true)
                "
                >Delete</a
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- Process Task Form -->
    <v-dialog
      v-model="showForm"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ cardTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showForm = false">
            <v-icon>{{ $getIcon("mdiClose") }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <process-task-form
            :objId="selectedObj.id"
            :obj="selectedObj"
            :defaultFormData="{
              organization: $store.state.shell.currentOrganizationId
            }"
            @action="formActionHandler"
          ></process-task-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- / Process Task Form -->
    <!-- Confirm Service Category Delete -->
    <v-dialog v-model="confirmServiceCategoryDelete" persistent max-width="390">
      <v-card>
        <vue-card-title
          :title="'Confirm Service Category Deletion'"
          :icon="$getIcon('mdiClipboardTextOutline')"
        >
          <template slot="actions">
            <v-btn
              icon
              small
              dark
              @click="confirmServiceCategoryDelete = false"
            >
              <v-icon v-text="$getIcon('mdiClose')" small> </v-icon>
            </v-btn>
          </template>
        </vue-card-title>
        <v-card-text>
          Are you sure you want to delete the service category -
          {{ selectedObj.name }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            @click="selectedObj = {} && (confirmServiceCategoryDelete = false)"
          >
            No
          </v-btn>
          <v-btn color="green darken-1" @click="deleteServiceCategory()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Confirm Service Category Delete -->
  </v-card>
</template>

<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import ProcessTaskForm from "./ProcessTaskForm";

export default {
  components: {
    ProcessTaskForm
  },
  mixins: [PaginationMixin],
  data() {
    return {
      searchLabel: "Search for process tasks..",
      cardTitle: "",
      showForm: false,
      selectedObj: {},
      organizationSlug: this.$store.state.shell.currentOrganizationId,
      confirmServiceCategoryDelete: false
    };
  },
  computed: {
    fetchAPI() {
      return (
        "/api/v1/crm/process-tasks/?organization__slug=" + this.organizationSlug
      );
    }
  },
  watch: {
    showForm(newVal) {
      if (Object.keys(this.selectedObj).length > 0 && newVal) {
        this.cardTitle = "Update Process Task";
      } else {
        this.selectedServiceCategoryData = {};
        this.cardTitle = "Create Process Task";
      }
    }
  },
  methods: {
    formSuccess() {
      this.serviceCategoryForm = false;
      this.fetchData();
    },
    formActionHandler() {
      this.showForm = false;
      this.fetchData();
    },
    deleteServiceCategory() {
      const deleteURL =
        "/api/v1/crm/process-tasks/" + this.selectedObj.id + "/";
      this.$axios
        .$delete(deleteURL)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully deleted service category.`,
            color: "green"
          });
          this.confirmServiceCategoryDelete = false;
          this.selectedObj = {};
          this.fetchData();
        })
        .catch(error => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `${error.response.data.message}`,
            color: "red"
          });
        });
    }
  }
};
</script>
